import React from 'react';

/**
 * Sayfa başlığı — API eskisiyle aynı: { title, subtitle, actions, botSelector }
 */
export default function PageHeader({ title, subtitle, actions, botSelector }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div className="page-header" style={{ marginBottom: botSelector ? 14 : 0 }}>
        <div style={{ minWidth: 0 }}>
          <h1 style={{ fontSize: 'clamp(19px, 2.3vw, 24px)', fontWeight: 700, color: 'var(--text)', lineHeight: 1.2, marginBottom: subtitle ? 3 : 0 }}>{title}</h1>
          {subtitle && <p style={{ color: 'var(--text3)', fontSize: 13.5 }}>{subtitle}</p>}
        </div>
        {actions && <div className="page-actions">{actions}</div>}
      </div>
      {botSelector || null}
    </div>
  );
}
